import { render, staticRenderFns } from "./AupairDocuments.vue?vue&type=template&id=16d109d6&"
import script from "./AupairDocuments.vue?vue&type=script&lang=js&"
export * from "./AupairDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports